import { combineReducers } from '@reduxjs/toolkit';

import { draftCommentsReducer } from './slices/draftCommentsSlice';
import { boardFiltersReducer } from './slices/filtersSlice';
import { newCommentsReducer } from './slices/newCommentsSlice';
import { tasksReducer } from './slices/tasks/tasksSlice';

export const tasksBoardReducer = combineReducers({
  filters: boardFiltersReducer,
  tasks: tasksReducer,
  newComments: newCommentsReducer,
  draftComments: draftCommentsReducer,
});

export { type QuickFilterKey, type OwnershipFilter, type PriorityFilter } from './slices/filtersSlice';

export {
  resetQuickFilters,
  setOwnershipFilter,
  toggleGoldenFilter,
  setPriorityFilter,
  toggleExpiredFilter,
  setHeaderTeam,
  setHeaderCreator,
  setHeaderAssignee,
  setCreatorRole,
  setSearch,
  setExpiredOnlyFilter,
  setDateRangeFilter,
  setDateRangeByFilter,
  setCategoryFilter,
} from './slices/filtersSlice';

export {
  setColumnTasks,
  setCursor,
  updateTask,
  addTask,
  updateTaskLastComment,
  upsertTask,
  removeTaskFromBoard,
  changeTaskUnreadCommentsCount,
  changeTaskCommentsCount,
  setIsFullyLoaded,
  setIsWorkTime,
} from './slices/tasks/tasksSlice';

export { setCommentRequest, setCommentBody, clearCommentDraft } from './slices/draftCommentsSlice';

export {
  addNewComment,
  markAsViewed,
  setFilter,
  clearReadComments,
  updateNewComment,
  deleteNewComment,
} from './slices/newCommentsSlice';

export { selectBoardTasksFilters } from './selectors/filters';
export {
  selectTasksByStatus,
  selectCursorByStatus,
  selectTaskById,
  selectTasksCountByStatus,
} from './selectors/tasks';
export { selectUnviewedCommentsCount, selectFilteredComments } from './selectors/newComments';
export { selectDraftComment } from './selectors/draftComments';

export { readAllNewCommentsThunk } from './thunks/readAllNewCommentsThunk';
export { readAllTasksThunk } from './thunks/readAllTasksThunk';
